import { PAGES } from "../pages";

export default function Sidebar({
  activePage,
  setActivePage,
  currentUser,
  actionMenuItems = [],
  logout,
  collapsed,
  onToggle
}) {
  const pages = currentUser?.pages || [];

  let items;

  if (currentUser?.role === "SYSTEM_ADMIN") {
    items = ["Компании"];
  } else {
    items = [];

    PAGES.forEach((page) => {
      if (!pages.includes(page.key)) {
        return;
      }

      if (page.key === "payments") {
        items.push("Реестр платежей", ...actionMenuItems.map((item) => item.label));
      } else {
        items.push(page.label);
      }
    });
  }

  return (
    <div className={`sidebar ${collapsed ? "collapsed" : ""}`}>
      <button
        className="sidebar-toggle"
        onClick={onToggle}
        title={collapsed ? "Открыть меню" : "Свернуть меню"}
      >
        {collapsed ? "»" : "«"}
      </button>

      {!collapsed && (
        <>
          <h2>PanFlow</h2>

          <div className="user-switcher">
            Текущий пользователь
            <strong>{currentUser?.name}</strong>
            <span>{currentUser?.username}</span>
            <span>{currentUser?.role_label}</span>
          </div>

          {items.map((item) => (
            <div
              key={item}
              className={`sidebar-item ${activePage === item ? "active" : ""}`}
              onClick={() => setActivePage(item)}
            >
              {item}
            </div>
          ))}

          <button className="logout-btn" onClick={logout}>
            Выход
          </button>
        </>
      )}
    </div>
  );
}
